var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cat",
    transform: "translate(13159 17249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4023",
    "data-name": "Rectangle 4023",
    width: 60,
    height: 60,
    transform: "translate(-13159 -17249)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-category-3977198",
    transform: "translate(-13155.357 -17245.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13322",
    "data-name": "Group 13322",
    transform: "translate(4.358 4.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13321",
    "data-name": "Group 13321",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M19.114,274.228A14.779,14.779,0,0,0,4.355,288.986v3.827a1.377,1.377,0,0,0,1.376,1.38H22.939a1.377,1.377,0,0,0,1.376-1.38V275.6a1.377,1.377,0,0,0-1.376-1.376Zm10.656,0a1.377,1.377,0,0,0-1.376,1.376v17.208a1.377,1.377,0,0,0,1.376,1.38H46.978a1.377,1.377,0,0,0,1.376-1.38v-3.827a14.779,14.779,0,0,0-14.759-14.758Zm-10.656,2.757h2.45v14.453H7.106v-2.452a11.983,11.983,0,0,1,12.008-12Zm12.031,0h2.45a11.983,11.983,0,0,1,12.008,12v2.451H31.145ZM5.731,298.417a1.377,1.377,0,0,0-1.376,1.38v3.827a14.779,14.779,0,0,0,14.759,14.758h3.825a1.377,1.377,0,0,0,1.376-1.375V299.8a1.377,1.377,0,0,0-1.376-1.38Zm32.64,0a9.982,9.982,0,1,0,9.983,9.983,9.988,9.988,0,0,0-9.983-9.983ZM7.106,301.173H21.564v14.453h-2.45a11.985,11.985,0,0,1-12.008-12Zm31.265,0a7.226,7.226,0,1,1-7.226,7.226A7.184,7.184,0,0,1,38.371,301.173Z",
    transform: "translate(-4.354 -274.228)",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat);
export default __webpack_public_path__ + "static/media/Cat.7818878e5e199ea9a4264ea08c388e97.svg";
export { ForwardRef as ReactComponent };